import { render, staticRenderFns } from "./ComplaintFiling.vue?vue&type=template&id=2a8b9cf6&scoped=true&"
import script from "./ComplaintFiling.vue?vue&type=script&lang=js&"
export * from "./ComplaintFiling.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintFiling.vue?vue&type=style&index=0&id=2a8b9cf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8b9cf6",
  null
  
)

export default component.exports